/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createArrayNode } from '../../factoriesAny.js';
export var ArrayNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createArrayNode: createArrayNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesArrayNode.generated.js
// module id = 616
// module chunks = 0